import { useToken } from "@gluestack-style/react";
import PageLoader from "components/general/PageLoader";
import { Box, Button, H1, ParagraphSmall } from "components/ui";
import { Slot, usePathname } from "expo-router";
import { Plus } from "lucide-react-native";
import React from "react";
import { useGetGroupQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";

import SiteCatalogueForm from "components/admin/SiteCatalogueForm";
import PopupModal from "components/general/PopupModal";

export default function Page() {
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	const [pageNumber, setPageNumber] = React.useState(1);
	const { data, isLoading, isFetching } = useGetGroupQuery({});
	const [addNew, setAddNew] = React.useState(false);
	const isMobile = useIsMobile();

	const pathname = usePathname();

	const isListPage = /^\/admin\/catalogues\/?$/.test(pathname);


	const handleClosePopupModal = () => {
		setAddNew(false);
	};

	if (isLoading || data == null) {
		return <PageLoader />;
	}
	if (isMobile) {
		return (
			<Box flex={1}>
				<Slot />
			</Box>
		);
	}
	return (
		<Box paddingVertical={32} paddingRight={28}>
			<Box flexDirection="row" mb={32} alignItems="center">
				<H1>Catalogues</H1>

				{isListPage && <Box ml={"auto"} alignItems="center" justifyContent="center">
					<Box flexDirection={isMobile ? "column" : "row"}>
						<Box flex={isMobile ? 1 : undefined}>
							<Button onPress={() => setAddNew(!addNew)} backgroundColor="$basicwhite" borderRadius={12} gap={4} borderColor="$primarylight" variant="outline" size="md" marginRight={isMobile ? 0 : 8}>
								<Plus color={resolvedPrimaryLight} />
								<ParagraphSmall
									sx={{
										color: "$primarylight",
									}}
								>
									Add New
								</ParagraphSmall>
							</Button>
						</Box>
					</Box>

					<PopupModal viewHeight={"auto"} animationIn={"fadeIn"} animationOut={"fadeOut"} scrollOffset={1} onBackdropPress={() => setAddNew(false)} isVisible={addNew} title="Create Catalogue">
						<SiteCatalogueForm closePopupModal={handleClosePopupModal} />
					</PopupModal>
				</Box>}
			</Box>

			<Box flexDirection="row" flex={1} padding={28} bg="$basicwhite" borderRadius={16} gap={28}>
				<Box flex={1}>
					<Slot />
				</Box>
			</Box>
		</Box>
	);
}
